module.exports = __webpack_public_path__ + "static/media/tipologia15.a45540a3.png";